let lightbox = null;
let lightboxImage = null;
let prevLightboxArrow = null;
let nextLightboxArrow = null;

let currentImages = [];
let currentImageIndex = 0;

export const initLightbox = (images) => {
  images = Array.from(images);

  if (!lightbox) {
    lightbox = document.createElement("div");
    lightbox.className = "lightbox";
    document.body.appendChild(lightbox);

    lightboxImage = document.createElement("img");
    lightbox.appendChild(lightboxImage);

    const lightboxNav = document.createElement("div");
    lightboxNav.className = "lightbox-navigation";
    lightbox.appendChild(lightboxNav);

    const lightboxClose = document.createElement("div");
    lightboxClose.className = "lightbox-close";
    lightboxClose.innerHTML = "X";
    lightbox.appendChild(lightboxClose);

    const updateLightboxImage = () => {
      const img = currentImages[currentImageIndex];
      lightboxImage.src = img.dataset.large || img.dataset.src || img.src;
    };

    const closeLightbox = () => {
      lightbox.style.display = "none";
      document.body.classList.remove("modal-open");
    };

    // Close lightbox
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox || e.target === lightboxImage) {
        closeLightbox();
      }
    });

    lightboxClose.addEventListener("click", (e) => {
      closeLightbox();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeLightbox();
      }
    });

    prevLightboxArrow = document.createElement("span");
    prevLightboxArrow.className = "prev-lightbox-arrow";
    prevLightboxArrow.innerHTML = "‹";
    lightboxNav.appendChild(prevLightboxArrow);

    nextLightboxArrow = document.createElement("span");
    nextLightboxArrow.className = "next-lightbox-arrow";
    nextLightboxArrow.innerHTML = "›";
    lightboxNav.appendChild(nextLightboxArrow);

    nextLightboxArrow.addEventListener("click", (e) => {
      e.stopPropagation();
      currentImageIndex = (currentImageIndex + 1) % currentImages.length;
      updateLightboxImage();
    });

    prevLightboxArrow.addEventListener("click", (e) => {
      e.stopPropagation();
      currentImageIndex =
        (currentImageIndex - 1 + currentImages.length) % currentImages.length;
      updateLightboxImage();
    });

    document.addEventListener("keydown", (e) => {
      if (lightbox.style.display === "flex") {
        if (e.key === "ArrowRight") {
          currentImageIndex = (currentImageIndex + 1) % currentImages.length;
          updateLightboxImage();
        } else if (e.key === "ArrowLeft") {
          currentImageIndex =
            (currentImageIndex - 1 + currentImages.length) %
            currentImages.length;
          updateLightboxImage();
        }
      }
    });

    lightbox.updateImage = updateLightboxImage;
  }

  // Attach click handlers
  images.forEach((img, index) => {
    img.addEventListener("click", () => {
      currentImages = images;
      currentImageIndex = index;

      if (currentImages.length <= 1) {
        prevLightboxArrow.style.display = "none";
        nextLightboxArrow.style.display = "none";
      } else {
        prevLightboxArrow.style.display = "";
        nextLightboxArrow.style.display = "";
      }
      lightbox.updateImage();
      lightbox.style.display = "flex";
      document.body.classList.add("modal-open");
    });
  });
};
